import styled from 'styled-components';

export default styled.div`
  display: grid;
  grid-row-gap: 0.5rem;
  margin: 1rem 0;
`;
